export const version: string = '2.0.0';
